import { render, staticRenderFns } from "./right-sidebar.vue?vue&type=template&id=02e2008a"
import script from "./right-sidebar.vue?vue&type=script&lang=js"
export * from "./right-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports